import React from "react";

const UploadPhotoModal = ({ isOpen, onClose, onUpload }) => {
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [preview, setPreview] = React.useState(null);

    const handleFile = (file) => {
        if (file && file.type.startsWith("image/")) {
            setSelectedFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleFileChange = (e) => {
        handleFile(e.target.files[0]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const file = e.dataTransfer.files[0];
        handleFile(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleSubmit = () => {
        if (selectedFile) {
            onUpload(selectedFile);
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-xs transition-all">
            <div className="bg-white dark:bg-gray-900 p-8 rounded-2xl shadow-3d w-full max-w-lg transform transition-all">
                <div className="flex justify-between items-start mb-6">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white font-nunito">
                        Upload Profile Photo
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
                    >
                        ✕
                    </button>
                </div>

                <label
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    className="group relative flex flex-col items-center justify-center h-64 border-2 border-dashed border-primary/20 rounded-xl hover:border-primary/40 dark:border-gray-700 dark:hover:border-gray-600 transition-colors cursor-pointer mb-8"
                >
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="hidden"
                    />
                    <div className="flex flex-col items-center text-center p-4 pointer-events-none">
                        <svg
                            className="w-12 h-12 mb-3 text-primary/50 group-hover:text-primary/70 dark:text-gray-600 dark:group-hover:text-gray-500 transition-colors"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                        </svg>
                        <p className="text-gray-600 dark:text-gray-400 font-medium">
                            Drag and drop or{" "}
                            <span className="text-primary dark:text-primary/80">browse files</span>
                        </p>
                        <p className="text-sm text-gray-500 dark:text-gray-500 mt-1">
                            JPEG, PNG up to 5MB
                        </p>
                    </div>
                </label>

                {preview && (
                    <div className="mb-6 flex justify-center">
                        <img
                            src={preview}
                            alt="Preview"
                            className="w-32 h-32 object-cover rounded-full shadow-sm border border-gray-200 dark:border-gray-700"
                        />
                    </div>
                )}

                <div className="flex justify-end space-x-4">
                    <button
                        className="px-6 py-2.5 font-medium rounded-lg text-gray-600 hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-gray-800 transition-all duration-200"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-6 py-2.5 bg-primary hover:bg-primary/90 text-white font-medium rounded-lg transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50"
                        onClick={handleSubmit}
                        disabled={!selectedFile}
                    >
                        Upload Photo
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UploadPhotoModal;
